export const isValidNoonReportId = (id: unknown): id is number =>
    typeof id === 'number' && Number.isSafeInteger(id) && id > 0;

export const getValidNoonReportIds = (ids: readonly unknown[] | null | undefined): number[] =>
    (ids ?? []).filter(isValidNoonReportId);
